export default "__VITE_ASSET__32b39086__"